enum ActionTypes {
  RESET = "app/broadcastFocusedScreenNotification/RESET",
  UPDATE_FOCUSED_SCREEN_NOTIFICATION = "app/broadcastFocusedScreenNotification/UPDATE_FOCUSED_SCREEN_NOTIFICATION",
}

export default ActionTypes;
